<div [id]="elementId" class="svg-wrapper"></div>
<div id="svg-hidden" class="svg-hidden-wrapper"></div>